import React, { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext({
  mode: "light", toggle: () => {},
  palette: "navy", setPalette: () => {},
  density: "cozy", setDensity: () => {},
});

export const PALETTE_OPTIONS = [
  { value: "navy", label: "سرمه‌ای کلاسیک", swatch: ["#1F4E79", "#2E74B5"] },
  { value: "indigo", label: "نیلی مدرن", swatch: ["#2B43C4", "#5B7BF5"] },
  { value: "emerald", label: "زمرد بانکی", swatch: ["#0E6E52", "#13A37B"] },
  { value: "slate", label: "اسلیت ایندیگو", swatch: ["#3C4663", "#5B6CFF"] },
];

export const DENSITY_OPTIONS = [
  { value: "comfortable", label: "متعادل" },
  { value: "relaxed", label: "بازتر" },
];

export function ThemeProvider({ children }) {
  const [mode, setMode] = useState(() => localStorage.getItem("theme-mode") || "light");
  const [palette, setPaletteState] = useState(() => localStorage.getItem("theme-palette") || "navy");
  const [density, setDensityState] = useState(() => localStorage.getItem("theme-density") || "comfortable");

  useEffect(() => {
    localStorage.setItem("theme-mode", mode);
    const root = document.documentElement;
    root.setAttribute("data-theme", mode);
    root.style.colorScheme = mode;          // کنترل‌های بومی (input date) هماهنگ شوند
    document.body.style.background = mode === "dark" ? "#0d1117" : "#eef1f6";
  }, [mode]);

  useEffect(() => {
    localStorage.setItem("theme-palette", palette);
    document.documentElement.setAttribute("data-palette", palette);
  }, [palette]);

  useEffect(() => {
    localStorage.setItem("theme-density", density);
    document.documentElement.setAttribute("data-density", density);
  }, [density]);

  const toggle = () => setMode((m) => (m === "dark" ? "light" : "dark"));

  return (
    <ThemeContext.Provider value={{
      mode, toggle,
      palette, setPalette: setPaletteState,
      density, setDensity: setDensityState,
    }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useThemeMode = () => useContext(ThemeContext);
